import { render, staticRenderFns } from "./resetTariff.vue?vue&type=template&id=57f4d58a&scoped=true&"
import script from "./resetTariff.vue?vue&type=script&lang=js&"
export * from "./resetTariff.vue?vue&type=script&lang=js&"
import style0 from "./resetTariff.vue?vue&type=style&index=0&id=57f4d58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f4d58a",
  null
  
)

export default component.exports